import Pill from "PFComponents/pill/pill";
import Tooltip from "PFComponents/tooltip/tooltip";
import { ProjectItem } from "PFCore/hooks/queries/bookings/projects/use_projects_entries";
import { useOptionalTranslation } from "PFCore/hooks/use_optional_translation";
import EditIcon from "PFIcons/edit.svg";
import ForbiddenIcon from "PFIcons/forbidden.svg";
import React, { useRef } from "react";

import css from "./activity_status_badge.module.scss";

type ActivityStatusBadgeProps = {
  status: ProjectItem["activity"]["state"];
};

export const ActivityStatusBadge = ({ status }: ActivityStatusBadgeProps): JSX.Element => {
  const ref = useRef<HTMLDivElement>(null);
  const { t } = useOptionalTranslation();
  const Icon = status === "draft" ? EditIcon : ForbiddenIcon;
  const tooltipText = status === "draft" ? t("draft") : t("closed");

  return (
    <Tooltip content={<div>{tooltipText}</div>} placement="top" ref={ref}>
      <Pill ref={ref} className={css.root}>
        <Icon width={13} height={13} className={css.icon} />
      </Pill>
    </Tooltip>
  );
};
